import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PopupMenu extends Vue {
  private popupMenuProps = {
    openOnClick: true,
    bottom: true,
    offsetY: true,
    transition: 'slide-y-transition',
    closeOnContentClick: false
  };

  @Prop({ default: null }) buttonText: string;

  $refs!: {
    menuRef: HTMLFormElement;
  };

  openMenu(): void {
    this.$refs.menuRef.isActive = true;
  }

  closeMenu(): void {
    this.$refs.menuRef.isActive = false;
  }
}
